exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-container{margin-top:50px;padding-top:100px;padding-bottom:100px;margin-bottom:50px;text-align:center}.error-container .error-header{padding:0 25% 0 25%}.error-container .error-greet{font-size:24px;font-weight:600}.error-container .error-message{margin-top:33px;font-size:20px;font-weight:500;max-width:630px;margin-right:auto;margin-left:auto}.error-container hr{width:60%;margin-top:42px;margin-bottom:42px;border-color:#323232}@media (max-width: 767px){.error-container .error-header{padding:66px 5% 35px 5%}.error-container .error-greet{font-size:24px}.error-container .error-message{margin-top:28px;font-size:18px}}\n", ""]);

// exports
